export default function Toxicity() {
  const pathStyle = {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    isCustomFont: 'none',
    fontFileUrl: 'none',
    fill: 'rgb(255, 255, 255)',
    opacity: 1,
  };
  return (
    <svg version="1.0" className="w-7 h-7" xmlns="http://www.w3.org/2000/svg"
 width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path style={pathStyle} d="M3330 5106 c-310 -45 -571 -163 -815 -368 -79 -66 -214 -210 -223
-238 -6 -17 -21 -11 -75 28 -138 102 -337 192 -516 233 -114 26 -371 36 -490
20 -391 -56 -751 -279 -964 -598 -115 -173 -176 -317 -218 -514 -29 -139 -32
-391 -6 -524 43 -218 134 -422 267 -602 20 -28 21 -34 9 -51 -8 -11 -35 -48
-61 -83 -100 -138 -181 -334 -213 -516 -20 -115 -20 -317 0 -435 78 -452 408
-839 840 -986 154 -52 234 -65 419 -67 l170 -2 42 -55 c114 -147 316 -238 500
-225 92 7 212 43 276 83 l41 26 116 -60 c209 -109 393 -158 626 -169 306 -13
611 72 871 243 294 193 509 488 609 834 l16 55 97 47 c390 189 571 664 411
1080 -36 92 -105 200 -184 286 l-57 62 47 73 c105 162 186 366 227 569 32 160
32 434 -1 588 -43 203 -149 466 -203 504 -26 18 -80 21 -109 6 -21 -12 -49
-60 -49 -85 0 -8 20 -57 44 -108 171 -360 191 -724 60 -1089 -48 -132 -114
-251 -214 -383 -50 -66 -60 -98 -40 -134 5 -10 44 -48 87 -86 137 -119 210
-240 240 -398 14 -73 15 -103 6 -185 -29 -258 -190 -467 -429 -557 -87 -33
-110 -55 -124 -119 -118 -524 -531 -909 -1065 -992 -210 -32 -461 -1 -661 81
-92 38 -138 63 -239 128 -71 46 -106 45 -166 -3 -205 -165 -481 -116 -612 108
-18 30 -44 64 -59 75 -26 20 -32 20 -142 7 -443 -51 -853 157 -1074 543 -86
150 -133 332 -133 517 0 143 13 227 52 345 49 146 121 267 234 395 72 81 72
113 0 200 -71 84 -124 165 -170 259 -213 430 -144 955 172 1313 236 266 550
408 903 408 291 0 555 -96 770 -280 67 -57 90 -70 127 -70 42 0 66 21 138 119
201 274 511 470 852 538 134 26 394 24 533 -6 111 -24 246 -71 361 -126 59
-28 75 -32 102 -24 67 18 98 94 61 147 -38 55 -305 162 -504 202 -135 28 -375
35 -510 16z"/>
<path style={pathStyle} d="M4563 4683 c-35 -7 -73 -59 -73 -100 0 -73 91 -119 155 -77 61 40 49
141 -19 169 -20 8 -37 14 -38 14 -2 -1 -13 -4 -25 -6z"/>
<path style={pathStyle} d="M1285 4311 c-71 -33 -139 -104 -157 -163 -10 -33 -19 -42 -68 -64
-195 -87 -244 -334 -99 -498 66 -76 210 -115 309 -83 l45 14 66 -65 67 -64
-22 -52 c-52 -118 -61 -171 -61 -346 1 -163 1 -166 38 -276 20 -61 37 -127 37
-147 0 -19 -14 -66 -32 -104 -28 -61 -32 -78 -32 -163 0 -112 20 -173 91 -277
l45 -66 -99 -98 -98 -98 -55 15 c-139 38 -293 -31 -360 -163 -21 -41 -25 -62
-25 -138 0 -78 4 -97 27 -141 33 -62 107 -130 160 -146 33 -10 42 -19 65 -70
26 -59 86 -124 139 -151 56 -29 139 -39 202 -27 70 15 102 31 153 77 83 75
122 218 86 320 l-14 42 47 46 46 46 25 -53 c32 -70 120 -158 191 -191 31 -15
87 -31 125 -37 91 -13 780 -13 863 1 133 21 249 104 305 216 16 32 30 60 32
62 2 3 25 -17 52 -43 l49 -48 -14 -45 c-44 -146 22 -302 157 -375 37 -19 59
-23 139 -23 80 0 102 4 138 23 62 33 126 101 147 154 15 41 24 50 81 78 232
114 231 448 -2 561 -61 29 -164 36 -224 15 l-45 -16 -104 104 -103 103 36 47
c19 26 50 77 68 114 30 62 32 74 33 172 0 94 -3 112 -28 168 -44 97 -44 117
-4 239 74 225 69 437 -15 641 l-22 53 63 63 63 63 46 -14 c145 -45 310 32 375
176 33 70 30 179 -5 251 -15 30 -35 64 -45 76 -30 33 -102 82 -132 89 -22 5
-32 17 -50 59 -50 121 -164 191 -301 184 -93 -4 -155 -33 -216 -101 -70 -78
-96 -204 -64 -302 12 -37 12 -37 -40 -90 l-52 -52 -77 46 c-204 123 -506 194
-750 176 -233 -16 -412 -69 -598 -176 l-81 -46 -51 51 -51 51 16 50 c32 103
-4 234 -87 313 -88 85 -230 107 -344 53z m193 -187 c25 -17 52 -64 52 -91 0
-10 -14 -46 -31 -79 -24 -47 -30 -68 -25 -90 4 -15 44 -66 91 -113 l83 -86
-44 -49 -43 -50 -89 86 c-49 47 -101 88 -117 92 -22 6 -42 0 -87 -23 -66 -35
-98 -38 -138 -14 -56 33 -70 107 -31 162 23 32 32 36 103 46 65 9 94 40 103
112 9 74 46 113 109 113 23 0 52 -7 64 -16z m2280 0 c30 -21 52 -66 52 -108 0
-56 39 -93 105 -101 94 -12 139 -69 116 -146 -23 -76 -105 -100 -175 -53 -24
17 -54 27 -77 28 -36 1 -46 -6 -129 -89 l-90 -89 -45 44 c-25 24 -45 49 -45
54 0 5 38 49 85 97 96 98 103 119 61 192 -40 69 -38 118 5 158 36 34 99 40
137 13z m-977 -328 c229 -44 433 -154 575 -310 106 -115 166 -238 192 -391 19
-113 7 -214 -40 -348 -27 -77 -33 -106 -32 -177 0 -74 4 -95 32 -157 51 -115
39 -198 -43 -299 -51 -62 -107 -102 -192 -140 -42 -18 -88 -44 -102 -59 -26
-25 -26 -28 -31 -208 -5 -194 -11 -217 -62 -263 -22 -21 -61 -44 -72 -44 -3 0
-6 11 -6 25 0 43 -27 82 -64 95 -69 22 -125 -17 -133 -94 l-6 -46 -67 0 -67 0
-7 48 c-7 56 -35 88 -83 98 -60 12 -109 -33 -115 -106 l-3 -35 -70 0 -70 0 -3
35 c-4 49 -21 79 -55 97 -61 31 -129 -7 -142 -79 -4 -21 -11 -38 -16 -38 -19
0 -93 77 -110 115 -15 33 -19 67 -19 200 0 200 -3 208 -115 253 -127 52 -210
126 -260 234 -34 72 -32 121 7 204 25 54 33 85 36 149 4 73 0 90 -34 190 -38
108 -39 113 -38 255 0 135 2 150 28 220 106 280 341 476 669 561 159 41 356
46 518 15z m-1056 -1988 c31 -15 45 -28 45 -42 0 -11 -60 -80 -150 -172 -101
-103 -150 -160 -151 -176 -2 -43 3 -63 27 -104 13 -22 24 -53 24 -68 0 -98
-116 -145 -189 -77 -23 22 -31 38 -31 64 0 74 -41 127 -97 127 -19 0 -48 6
-66 14 -96 40 -87 177 13 207 37 11 44 10 102 -20 92 -49 98 -46 268 124 80
80 148 145 152 145 4 0 28 -10 53 -22z m1860 -119 c77 -78 154 -147 172 -155
35 -15 45 -13 118 24 40 19 59 23 87 18 74 -14 111 -99 71 -167 -18 -30 -44
-44 -108 -54 -22 -4 -48 -11 -58 -17 -23 -12 -47 -67 -47 -109 0 -22 -10 -41
-34 -65 -28 -28 -42 -34 -76 -34 -34 0 -48 6 -76 34 -42 42 -45 88 -10 145 24
38 29 56 27 100 -1 16 -49 72 -157 181 -108 109 -155 164 -152 177 2 14 75 61
98 63 3 0 68 -63 145 -141z"/>
<path style={pathStyle} d="M1960 2707 c-211 -59 -303 -301 -187 -490 61 -100 165 -151 307 -151
72 1 95 5 148 29 125 56 197 175 190 315 -6 125 -74 226 -188 279 -65 30 -197
39 -270 18z m190 -202 c88 -45 95 -167 13 -220 -39 -26 -137 -26 -180 0 -82
49 -82 162 -1 214 40 25 125 28 168 6z"/>
<path style={pathStyle} d="M2930 2707 c-211 -59 -303 -301 -187 -490 61 -100 165 -151 307 -151
71 1 95 5 147 29 256 114 258 476 3 594 -65 30 -197 39 -270 18z m190 -202
c88 -45 95 -167 13 -220 -39 -26 -137 -26 -180 0 -82 49 -82 162 -1 214 40 25
125 28 168 6z"/>
<path style={pathStyle} d="M2496 2169 c-44 -34 -133 -153 -173 -228 -47 -91 -55 -168 -24 -228
37 -74 127 -108 209 -79 28 10 50 13 60 7 10 -5 37 -12 62 -16 115 -17 225 94
204 206 -16 87 -127 259 -213 332 -40 33 -87 36 -125 6z m87 -268 l26 -40 -33
6 c-18 3 -44 0 -57 -7 -23 -13 -23 -13 -8 11 9 13 22 34 30 47 8 12 14 22 15
22 1 0 13 -18 27 -39z"/>
</g>
</svg>
  );
}
